import { render, staticRenderFns } from "./SlideFormSpal.vue?vue&type=template&id=07160d24&scoped=true"
import script from "./SlideFormSpal.vue?vue&type=script&lang=js"
export * from "./SlideFormSpal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07160d24",
  null
  
)

export default component.exports